import api from "./api";

export const createDriverPartnerPayout =
    async (payload) => {
        try {
            const response =
                await api.post(
                    "/driver-partner-payout-management/create",
                    payload
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data: response.data.data,
                    message:
                        response.data
                            .message,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.message ||
                    "Unexpected response from server",
            };
        } catch (error) {
            console.error(
                "Error creating payout:",
                error
            );

            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.response
                        ?.data
                        ?.message ||
                    error.message ||
                    "Failed to create payout",
            };
        }
    };

export const fetchDriverPartnerPayouts =
    async (
        page = 1,
        size = 10
    ) => {
        try {
            const response =
                await api.get(
                    `/driver-partner-payout-management/get?page=${page}&size=${size}`
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data:
                        response.data
                            .data,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.message ||
                    "Unexpected response from server",
            };
        } catch (error) {
            console.error(
                "Error fetching payouts:",
                error
            );

            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.response
                        ?.data
                        ?.message ||
                    error.message ||
                    "Failed to fetch payouts",
            };
        }
    };